import type { LabelFormat } from '@/api/types/common';

/**
 * Human-readable label-format choices shown to merchants. Restricted to the
 * printable formats (the `+json` variants return base64 JSON, not a file), so
 * the same list backs both the per-shipment download dialog and the account
 * default-format setting.
 */
export const LABEL_FORMAT_OPTIONS: { value: LabelFormat; label: string }[] = [
  { value: 'application/pdf;format=A6', label: 'PDF A6' },
  { value: 'application/pdf;format=A4', label: 'PDF A4' },
  { value: 'text/zpl;dpi=203', label: 'ZPL 203 dpi' },
  { value: 'text/zpl;dpi=300', label: 'ZPL 300 dpi' },
  { value: 'text/epl2;dpi=203', label: 'EPL2' },
  { value: 'text/dpl;dpi=203', label: 'DPL' },
];
